/** Accept a public HTTPS origin, never a local address or an arbitrary page. */
export function normalizeSiteUrl(value: string | undefined): string | null {
  if (!value?.trim()) return null
  try {
    const url = new URL(value.trim())
    const host = url.hostname.toLowerCase()
    if (
      url.protocol !== "https:" ||
      url.username ||
      url.password ||
      url.search ||
      url.hash ||
      url.port ||
      url.pathname !== "/" ||
      !host.includes(".") ||
      /^[\d.]+$/.test(host) ||
      host.includes(":") ||
      /(?:^|\.)(?:localhost|local|test|example|invalid|internal)$/.test(host)
    )
      return null
    return url.origin
  } catch {
    return null
  }
}
